import React from "react";
import { useSelector } from "react-redux";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerToggleButton,
} from "@pacerpro/shared-ui";
import { selectOrganizationDrawer } from "../../selectors";
import AdminForm from "./AdminForm";

interface Props {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

const OrganizationDrawer: React.FunctionComponent<Props> = ({
  isOpen,
  onOpen,
  onClose,
  onToggle,
}) => {
  const drawerState = useSelector(selectOrganizationDrawer);
  return (
    <Drawer
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      onToggle={onToggle}
      size={"lg"}
    >
      <DrawerOverlay />
      <DrawerContent>{drawerState === "admin" && <AdminForm />}</DrawerContent>
      <DrawerToggleButton />
    </Drawer>
  );
};

export default OrganizationDrawer;
